import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from '../actions';
import { tap, mergeMap, map, catchError, switchMap } from 'rxjs/operators';

import { Observable, of } from 'rxjs';
import { AuthorService, SearchService } from 'app/services';

@Injectable()
export class AuthorsEffects {
  constructor(
    private actions$: Actions,
    private authorService: AuthorService,
    private searchService: SearchService
  ) {}

  loadAuthorContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.setAuthors),
      mergeMap(action =>
        this.getContents$(action).pipe(
          switchMap(response => [
            actions.setAuthorsSuccess({
              contents: { ...response }
            })
          ]),
          catchError(err => of(actions.setAuthorsError({ payload: err })))
        )
      )
    )
  );

  getContents$(action): Observable<any> {
    if (action.isSearch) {
      return this.searchService.search(
        action.searchBody,
        action.sort,
        'authors',
        action.page,
        action.size
      );
    } else {
      return this.authorService.getAuthorsForTopic(
        action.topicId,
        action.sort,
        action.page,
        action.size
      );
    }
  }
}
